import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getMe } from '@/shared/api/auth';
import type { User } from '@/shared/api/types';

/** Cache key of the signed-in user; null in the cache means signed out. */
export const sessionQueryKey = ['session'] as const;

/** How the signed-in user is loaded, for hooks and for imperative fetches alike. */
export const sessionQuery = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: ({ signal }): Promise<User | null> => getMe(signal),
  staleTime: Infinity,
});

/** The signed-in user, or null when there is no session. */
export function useSession(): UseQueryResult<User | null> {
  return useQuery(sessionQuery);
}
